import { createElement } from "@max/max";
import View from '@hfe/max-view';
import CountDownDescription from '../../common/CountDownDescription';
import Price from "../../common/Price/index.web";
import CouponTitle from '../../common/CouponTitle';
import CouponThreshold from '../../common/CouponThreshold';
import { LayoutType } from '../../../types/shared';
import './index.scss';
import Button from '@/components/common/Button';
import { formatRequireAmount } from '@/utils/common';
const CouponCardSingle = ({ prize, onPress }) => {
    const isButtonValid = prize.isButtonValid;
    const requireAmount = formatRequireAmount(prize.requireAmount);
    return <View className="coupon-card-single" onClick={() => onPress(prize)}>
      <View className="coupon-content">
        <View className="left-section">
          <Price amount={prize.amount} amountType={prize.amountType} rewardType={prize.rewardType}/>
          <CouponThreshold text={requireAmount} style={{
            marginTop: '-8rpx'
        }}/>
        </View>
        <View className="middle-section">
          <CouponTitle title={prize.prizeName} layoutType={LayoutType.SINGLE} style={{
            marginBottom: '6rpx'
        }}/>
          <CountDownDescription prize={prize}/>
        </View>
        <View className="button-wrapper">
          <Button width={160} height={60} children={prize.buttonText} fontSize={28} handlePress={() => onPress?.(prize)} backgroundColor={isButtonValid ? '#FF2D19' : '#CCCCCC'}/>
        </View>
      </View>
    </View>;
};
export default CouponCardSingle;
